class State {

  constructor(_machine="machine"){
   this._machine = _machine
  }

  get gameData(){
    return this.gameSelector ? vue.toRaw(this.gameSelector.data) : null
  }

  get machine(){
    return window[this._machine]
  }
  get game(){
    return this.machine && this.machine.game
  }

  get wasmTTL(){
    return parseInt(readCookie("wasmttl") || 500)
  }
  set wasmTTL(v){
    createcookie("wasmttl", v, 1)
  }

  get currentUser(){
    return this._currentUser
  }
  set currentUser(u){
    this._currentUser = u
  }

  get ready(){
   return this.machine.ready()
  }
  // sigh fix me
  get allCardsSelected(){
    return this.game && this.game.numCardsSelected == 5
  }

  get notAllCardsSelected() {
    return !this.game || this.game.numCardsSelected < 5
  }


  get noCardsSelected(){
    return !this.game || this.game.numCardsSelected == 0
  }

  get someCardsSelected() {
    return this.game && this.game.numCardsSelected > 0
  }

  get vpgameid(){
    return _vpgameid
  }
  set vpgameid(v){
    this._vpgameid = v
  }

  get hand() {
    return this._hand
  }
  set hand(v) {
    this._hand = v
  }

}

export default State